import React, { useState } from 'react';
import * as styles from './PostSeriesInTopicList.module.scss';
import SVGIcon from '../../components/SVGIcon';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import seriesIcon from '../../icons/non-prefilled/16x16/series.svg';
import SeriesHoverCard from '../../series/SeriesHoverCard';
import PostTopicListItem from '../topic/PostTopicListItem';

const NATURAL_POP_OVER_WIDTH = parseInt(styles.seriesCardWidth, 10);

const SERIES_FRAGMENT = gql(`
  fragment PostSeriesInTopicList_series on SeriesFields {
    id
    name
    posts {
      id
    }
  }
`);

const SERIES_DETAILS_FRAGMENT = gql(`
  fragment PostSeriesInTopicList_seriesDetails on SeriesFields {
    id
    ...SeriesHoverCard_series
  }
`);

interface PostSeriesInTopicListProps {
  series?: DocumentType<typeof SERIES_FRAGMENT>;
  seriesDetails?: DocumentType<typeof SERIES_DETAILS_FRAGMENT>;
  postId: string;
}

const PostSeriesInTopicList = ({
  series,
  seriesDetails,
  postId,
}: PostSeriesInTopicListProps) => {
  const indexInSeries = series?.posts.findIndex((post) => post.id === postId);
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);

  if (series == null || indexInSeries == null || indexInSeries === -1) {
    return null;
  }

  return (
    <PostTopicListItem.Root>
      <PostTopicListItem.PopOver
        open={isPopOverOpen}
        onOpenChange={setIsPopOverOpen}
        trigger="clickOrHover"
        popOver={
          <SeriesHoverCard
            postId={postId}
            series={seriesDetails}
            showEditButton
            onClickEditButton={() => setIsPopOverOpen(false)}
          />
        }
        naturalWidth={NATURAL_POP_OVER_WIDTH}
      >
        <PostTopicListItem.Content
          icon={
            <SVGIcon className={styles.seriesIcon} role="presentation">
              {seriesIcon}
            </SVGIcon>
          }
          name={series.name}
          description={`Part ${indexInSeries + 1} of ${series.posts.length}`}
        />
      </PostTopicListItem.PopOver>
    </PostTopicListItem.Root>
  );
};

export default PostSeriesInTopicList;
